import type {Theme as MuiTheme} from '@yandex-delivery/blocks/theme/types'
import {SystemColors, createMuiTheme, dark as goDark, light as goLight} from '@yandex-taxi/go-web-components'
import type {Theme} from 'src/shared/hooks/useTheme'

export function createRouteMuiTheme(mode: Theme, dir: 'ltr' | 'rtl'): MuiTheme {
  const goTheme = mode === 'dark' ? goDark : goLight
  const theme = createMuiTheme(goTheme, dir)
  const fontFamily = `"Yandex Sans Text Web", ${theme.typography.fontFamily}`

  theme.palette.primary.main = theme.go.schemes.colors.system[SystemColors.ControlMain]
  theme.palette.text.primary = theme.go.schemes.colors.system[SystemColors.TextMain]
  theme.palette.text.secondary = theme.go.schemes.colors.system[SystemColors.TextMinor]
  theme.palette.action.active = theme.go.schemes.components.buttons.default.textColor
  theme.palette.background.default = theme.go.schemes.colors.system.BgMinor

  if (mode === 'dark') {
    theme.palette.background.default = '#191918'
    theme.palette.background.paper = '#302F2D'
    theme.palette.text.primary = '#E0DEDA'
    theme.palette.text.secondary = 'rgba(224, 222, 218, 0.5)'
  }

  theme.typography.fontFamily = fontFamily
  theme.typography.body1.fontFamily = fontFamily
  theme.typography.body1.letterSpacing = 'normal'
  theme.typography.body2.fontFamily = fontFamily
  theme.typography.body2.fontSize = theme.typography.pxToRem(16)
  theme.typography.body2.letterSpacing = 'normal'
  theme.typography.button.fontFamily = fontFamily

  if (theme.props?.MuiInputLabel?.disableAnimation) {
    theme.props.MuiInputLabel.disableAnimation = false
  }

  delete theme.props?.MuiInputLabel?.shrink

  return theme
}
